import { createSlice } from '@reduxjs/toolkit';

export const FilesSlice = createSlice({
  name: 'files',
  initialState: {
    arl_list: [],
  },
  reducers: {
    setImageRedux: (state, { payload }) => {
      state.arl_list = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setImageRedux } = FilesSlice.actions;
